/// <reference path="../app.definition.ts" />

import angular from 'angular';



import './factory/factory.module';
import './popup/popup.module';
import './service/services.module';
import './directive/directives.module';
import './filter/filters.module';
import './api/api.module';
import './apiadapter/apiadapter.module';
import './share/share.module';
import './menuOptions/menuOptions.module';
import './userSelector/user-selector.module';
import './crSelector/cr-selector.module';
import './mugshotList/mugshot-list.module';
import './mugshot/mugshot.module';
import './passwordCollector/passwordCollector.module';
import './formTemplate/formTemplate.module';
import './schemaFormUtility/schemaFormUtility.module';
import './customAttributeTemplate/customAttributeTemplate.module';
import './analyticsReport/analyticsReport.module';
import './carefeedBoard/carefeedBoard.module';

angular.module('eCareVault.common', [
    'eCareVault.common.factory',
    'eCareVault.common.popUp',
    'eCareVault.common.services',
    'eCareVault.common.directives',
    'eCareVault.common.filters',
    'eCareVault.common.JavaApiAdapterService',
    'eCareVault.common.APIService',
    'eCareVault.common.share',
    'eCareVault.common.menuOptions',
    'eCareVault.common.userSelector',
    'eCareVault.common.crSelector',
    'eCareVault.common.mugshotList',
    'eCareVault.common.mugshot',
    'eCareVault.common.passwordCollector',
    'eCareVault.common.formTemplate',
    'eCareVault.common.schemaForm',
    'eCareVault.customAttributeTemplate',
    'eCareVault.common.analyticsReport',
    'eCareVault.common.carefeedBoard'
]);
